import React from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

export default function LinkExpired({ type }) {

    const { t } = useTranslation();

    return (
        <div className='LinkExpired'>
            <img className='wrong' src="./assets/img/icons/dangerous_FILL0_wght400_GRAD0_opsz48.svg" alt="" />
            <h2>{t(type === 'invalid' ? 'Invalid Link' : 'sorry_the_link_has_expired')}&nbsp;!</h2>
            <Link className='next-button' to={'/'} rel="noreferrer">
                <img className='arrow left' src="./assets/img/icons/Icon awesome-arrow-right.svg" alt="" />
                {t('back_to_home_page')}
            </Link>
        </div>
    )
}
